module.exports = __webpack_public_path__ + "assets/429795eabbc698223fca49b7c0a47c63.svg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/invoice_icon.svg
// module id = 3643
// module chunks = 0